import { render, staticRenderFns } from "./AddAdvocatAppItem.vue?vue&type=template&id=9ba71a3a&scoped=true&lang=pug&"
import script from "./AddAdvocatAppItem.vue?vue&type=script&lang=js&"
export * from "./AddAdvocatAppItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba71a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VLayout})
